import { GC_GET_GAME_LIST } from '@/graphql/game';
import apollo from '@/apolloClient';

export default {
    namespaced: true,
    state: {
        list: []
    },
    mutations:{
        SET_GAME_LIST(state, games){
            state.list = (games || [])
        }
    },
    actions: {
        async getList({ commit }) {
            const response = await apollo.query({ query: GC_GET_GAME_LIST })

            commit('SET_GAME_LIST', response.data.game)
        }
    }
}